import { ListContextProvider, useListContext } from '../../list-context/ListContextProvider';
import { InfoCardListProps } from './@types/InfoCardListProps';
import InfoCardListContainer from './handles/InfoCardListContainer';

const InfoCardList = (props: InfoCardListProps) => {
	const wrapper = props.children[0];
	const blockClass = wrapper?.props?.comp?.props?.blockClass;
	const imageListContent =
		props?.infoCards?.map((props, idx) => (
			<InfoCardListContainer key={idx} {...props} childrenBlockClass={blockClass} />
		)) || [];
	const list = useListContext()?.list ?? [];
	const newListContextValue = list.concat(imageListContent);

	return <ListContextProvider list={newListContextValue}>{props.children}</ListContextProvider>;
};

export default InfoCardList;
